










import Vue from 'vue';
import Component from 'vue-class-component';

// Internal system components
import SystemSummary from './SystemSummary.vue';
import SystemSpecsLink from './SystemSpecsLink.vue';

/**
 *  Component that holds the heading of a system, including the
 *  brand, product line, SKU and a button to request the
 *  parent to open the specs.
 */
@Component({
    components: {
        SystemSummary,
        SystemSpecsLink,
    },
})
export default class SystemHeading extends Vue {}
